/* eslint-disable perfectionist/sort-imports */
import { Box } from '@mui/material';
import 'src/global.css';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import Router from 'src/routes/sections';
import ThemeProvider from 'src/theme';

// Import Component ที่สร้างใหม่ (ตรวจสอบ path ให้ถูกต้อง)
import CookieConsent from './sections/CookieConsent/CookieConsent';
import TechnicianServiceWrapper from './components/TechnicianServiceWrapper';

// ----------------------------------------------------------------------

function BsrSiteWave() {
  return (
    <svg
      className="bsr-site-wave"
      viewBox="0 0 640 340"
      fill="none"
      preserveAspectRatio="xMaxYMin slice"
      aria-hidden
    >
      <path
        d="M640 0v210c-90 40-160-20-260 10S180 300 60 250-40 120 40 60 220-20 380 20s180-60 260-20z"
        fill="#dbe8f5"
        opacity=".5"
      />
      <path
        d="M640 0v150c-70 30-130-10-210 15s-120 70-220 40S-10 150 60 90 260 30 380 55 560 20 640 40z"
        fill="#dbe8f5"
        opacity=".4"
      />
    </svg>
  );
}

export default function App() {
  useScrollToTop();

  return (
    <ThemeProvider>
      <TechnicianServiceWrapper>
        <BsrSiteWave />
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            width: '100%',
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            bgcolor: 'transparent',
          }}
        >
          <Router />

          {/* เรียกใช้ Component ตรงนี้ จบเลย ง่ายมาก */}
          <CookieConsent />
        </Box>
      </TechnicianServiceWrapper>
    </ThemeProvider>
  );
}